import { Text, Title3, mergeClasses } from '@fluentui/react-components';
import { CalendarEmpty24Regular } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { BasicButton } from '@components/common/BasicButton';
import type { EmptyStateProps } from '@/types/events.types';
import { useEmptyStateStyles } from './EmptyState.styles';

export const EmptyState = ({
  tab,
  onCreateRequest,
  figmaVariant = false,
}: EmptyStateProps & { figmaVariant?: boolean }) => {
  const styles = useEmptyStateStyles();
  const { t } = useTranslation('dashboard');

  const content = {
    draft: {
      title: t('empty.draft.title'),
      description: t('empty.draft.description'),
      showAction: true,
      actionLabel: t('empty.draft.action'),
    },
    current: {
      title: t('empty.current.title'),
      description: t('empty.current.description'),
      showAction: false,
      actionLabel: '',
    },
    past: {
      title: t('empty.past.title'),
      description: t('empty.past.description'),
      showAction: false,
      actionLabel: '',
    },
  }[tab];

  return (
    <div
      className={mergeClasses(styles.container, figmaVariant && styles.containerFigma)}
      role="status"
      aria-live="polite"
    >
      {figmaVariant ? (
        <span className={styles.iconBadgeFigma} aria-hidden="true">
          <CalendarEmpty24Regular className={styles.iconFigma} />
        </span>
      ) : (
        <CalendarEmpty24Regular className={styles.icon} aria-hidden="true" />
      )}
      <Title3 className={styles.title}>{content.title}</Title3>
      <Text className={styles.description}>{content.description}</Text>
      {content.showAction && onCreateRequest && (
        <BasicButton variant="primary" size="medium" onClick={onCreateRequest}>
          {content.actionLabel}
        </BasicButton>
      )}
    </div>
  );
};

EmptyState.displayName = 'EmptyState';
